<template>
    <div>
        <div class="card" v-if="pageWidth>1000">
            <div class="drone">
                <div class="text animate__animated animate__fadeInLeft">
                    <!-- 简介 -->
                    <div class="droneDetection">
                        <div>
                            <h2 class="title">04 <span>牧星系列反无人机监测系统</span></h2>
                            <p style="text-indent: 2em;">
                                牧星系列无人机监测系统基于雷达、无线电频谱、光电等设备，实现对监测区域内的无人机（机群）进行全方位的态势感知。本系统适用于重要区域的低空安全防护、重大活动的空域保障以及机场、铁路、边境等关键场所的无人机监管，为维护低空空域安全提供了高效、多样、可靠的解决方案。</p>
                        </div>
                        <div class="image animate__animated animate__fadeInRight">
                            <img src="../../../assets/solution/fanwu/drone1.png" alt="">
                        </div>
                    </div>

                    <!-- 技术要点 -->
                    <div class="technicalPoints">
                        <h3 class="title"><span>产品特色</span></h3>
                        <div>
                            <h4>多手段</h4>
                            <p>充分发挥分布式雷达在远距离、频谱在中远距离及多光谱在近距离，三维精细化信息处理方面的优势。解决在恶劣天气、“静默”条件及广范围情况下无人机探测困难的行业难题。</p>
                        </div>
                        <div>
                            <h4>高可靠</h4>
                            <p>运用雷达主动感知，频谱侦测设备与多光谱设备被动感知协同探测架构，融合主动与被动探测优势。通过地面分布式部署的监测设备结合空中抵近观测的无人机，实现对潜在无人机（机群）的探测并跟踪，对所采集到的数据进行融合分析，生成监测区全方位的无人机态势感知地图，保障监测区的低空空域安全。</p>
                        </div>
                        <div>
                            <h4>易操作</h4>
                            <p>系统设计人性化，操作步骤少，便于各类人员快速上手。</p>
                        </div>
                    </div>

                    <!-- 关键指标 -->
<!--                    <div>-->
<!--                        <h3 class="title"><span>关键指标</span></h3>-->
<!--                        <div class="keyMetrics">-->
<!--                            <div style="width: 1280px">-->
<!--                                <table>-->
<!--                                    <thead>-->
<!--                                    <tr>-->
<!--                                        <th>序号</th>-->
<!--                                        <th>指标项</th>-->
<!--                                        <th>详细指标</th>-->
<!--                                    </tr>-->
<!--                                    </thead>-->
<!--                                    <tbody>-->
<!--                                    <tr>-->
<!--                                        <td>1</td>-->
<!--                                        <td class="mark">定位方式</td>-->
<!--                                        <td class="mark">到达时间差（TDOA）</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>2</td>-->
<!--                                        <td>探测作用对象</td>-->
<!--                                        <td>无人机图传、遥控信号</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>3</td>-->
<!--                                        <td>探测频段-->
<!--                                        </td>-->
<!--                                        <td>100MHz~6GHz</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>4</td>-->
<!--                                        <td>探测角度-->
<!--                                        </td>-->
<!--                                        <td>水平 0°~360° 俯仰 -60°~90°</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>5</td>-->
<!--                                        <td>探测高度-->
<!--                                        </td>-->
<!--                                        <td>0~500m-->
<!--                                        </td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>6</td>-->
<!--                                        <td>探测作用半径-->
<!--                                        </td>-->
<!--                                        <td>2-6公里（单台探测设备，根据工作环境和目标机型不同会存在一定差异）-->
<!--                                        </td>-->
<!--                                    </tr>-->

<!--                                    <tr>-->
<!--                                        <td>7</td>-->
<!--                                        <td>探测成功率-->
<!--                                        </td>-->
<!--                                        <td>≥95%-->
<!--                                        </td>-->
<!--                                    </tr>-->

<!--                                    <tr>-->
<!--                                        <td>8</td>-->
<!--                                        <td>测向精度-->
<!--                                        </td>-->
<!--                                        <td>≤3°-->
<!--                                        </td>-->
<!--                                    </tr>-->

<!--                                    <tr>-->
<!--                                        <td>9</td>-->
<!--                                        <td>定位精度-->
<!--                                        </td>-->
<!--                                        <td>≤30m-->
<!--                                        </td>-->
<!--                                    </tr>-->

<!--                                    <tr>-->
<!--                                        <td>10</td>-->
<!--                                        <td>跟踪性能-->
<!--                                        </td>-->
<!--                                        <td>0m/s~20m/s-->
<!--                                        </td>-->
<!--                                    </tr>-->

<!--                                    <tr>-->
<!--                                        <td>11</td>-->
<!--                                        <td>刷新时间-->
<!--                                        </td>-->
<!--                                        <td>≤2s-->
<!--                                        </td>-->
<!--                                    </tr>-->

<!--                                    <tr>-->
<!--                                        <td>12</td>-->
<!--                                        <td>多目标轨迹跟踪数量-->
<!--                                        </td>-->
<!--                                        <td>≥3-->
<!--                                        </td>-->
<!--                                    </tr>-->
<!--                                    </tbody>-->
<!--                                </table>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </div>
            <div class="compose">
                <div class="text" ref="text">
                    <div>
                        <h3 class="title"><span>产品形态</span></h3>
                        <div class="productForm">
                            <div>
                                <img src="../../../assets/solution/fanwu/FG20M.png" alt="">
                                <h4>多模态无人机</h4>
                                <p>综合利用多种传感器技术的无人机，具备多方面的监测和应对能力。</p>
                            </div>
                            <div>
                                <img src="../../../assets/solution/fanwu/drone_model2.png" alt="">
                                <h4>固定台站式无人机侦测反制</h4>
                                <p>在固定位置设置专门设备，用于监测和应对周围无人机的行为。</p>
                            </div>
                            <div>
                                <img src="../../../assets/solution/fanwu/drone_model1.png" alt="">
                                <h4>无人机防控指挥车</h4>
                                <p>一种移动式指挥车辆，集成了无人机侦测与反制设备，用于灵活应对不同场景下的无人机威胁。</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h3 class="title"><span>应用场景</span></h3>
                        <div class="scenario">
                            <div ref="text">
                                <div>
                                    <h4>重大活动保障</h4>
                                    <p>
                                        在重大活动空域实时掌控监测区无人机态势情况，快速定位非法无人机，防范其对活动造成安全隐患。</p>
                                </div>
                                <div>
                                    <h4>低空要地防护</h4>
                                    <p>
                                        监测铁路、机场、化工厂、边境等重要场所低空空域，及时定位威胁安全的无人机，保障低空安全。</p>
                                </div>
                            </div>

                            <div class="image_box" ref="img">
                                <img src="@/assets/solution/fanwu/anli1.png" alt="">
                                <img src="@/assets/solution/fanwu/anli2.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" v-else>
            <div class="drone">
                <div class="text animate__animated animate__fadeInLeft">
                    <h2 class="title">04 <span>牧星系列反无人机监测系统</span></h2>
                    <p style="text-indent: 2em;">
                        牧星系列无人机监测系统基于雷达、无线电频谱、光电等设备，实现对监测区域内的无人机（机群）进行全方位的态势感知。本系统适用于重要区域的低空安全防护、重大活动的空域保障以及机场、铁路、边境等关键场所的无人机监管，为维护低空空域安全提供了高效、多样、可靠的解决方案。
                    </p>
                    <div class="image animate__animated animate__fadeInRight">
                        <img src="../../../assets/solution/fanwu/drone1.png" alt="">
                    </div>
                    <div class="technicalPoints">
                        <h3 class="title"><span>技术要点</span></h3>
                        <div>
                            <h4>多手段</h4>
                            <p>充分发挥分布式雷达在远距离、频谱在中远距离及多光谱在近距离，三维精细化信息处理方面的优势。解决在恶劣天气、“静默”条件及广范围情况下无人机探测困难的行业难题。</p>
                        </div>
                        <div>
                            <h4>高可靠</h4>
                            <p>运用雷达主动感知，频谱侦测设备与多光谱设备被动感知协同探测架构，融合主动与被动探测优势。通过地面分布式部署的监测设备结合空中抵近观测的无人机，实现对潜在无人机（机群）的探测并跟踪，对所采集到的数据进行融合分析，生成监测区全方位的无人机态势感知地图，保障监测区的低空空域安全。</p>
                        </div>
                        <div>
                            <h4>易操作</h4>
                            <p>系统设计人性化，操作步骤少，便于各类人员快速上手。</p>
                        </div>

<!--                        <h3 class="title"><span>关键指标</span></h3>-->
<!--                        <div class="keyMetrics">-->
<!--                            <div>-->
<!--                                <table>-->
<!--                                    <thead>-->
<!--                                    <tr>-->
<!--                                        <th>序号</th>-->
<!--                                        <th>指标项</th>-->
<!--                                        <th>详细指标</th>-->
<!--                                    </tr>-->
<!--                                    </thead>-->
<!--                                    <tbody>-->
<!--                                    <tr>-->
<!--                                        <td>1</td>-->
<!--                                        <td class="mark">定位方式</td>-->
<!--                                        <td class="mark">到达时间差（TDOA）</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>2</td>-->
<!--                                        <td>探测作用对象</td>-->
<!--                                        <td>无人机图传、遥控信号</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>3</td>-->
<!--                                        <td>探测频段-->
<!--                                        </td>-->
<!--                                        <td>100MHz~6GHz</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>4</td>-->
<!--                                        <td>探测角度-->
<!--                                        </td>-->
<!--                                        <td>水平 0°~360° 俯仰 -60°~90°</td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>5</td>-->
<!--                                        <td>探测高度-->
<!--                                        </td>-->
<!--                                        <td>0~500m-->
<!--                                        </td>-->
<!--                                    </tr>-->
<!--                                    <tr>-->
<!--                                        <td>6</td>-->
<!--                                        <td>探测作用半径-->
<!--                                        </td>-->
<!--                                        <td>2-6公里（单台探测设备，根据工作环境和目标机型不同会存在一定差异）-->
<!--                                        </td>-->
<!--                                    </tr>-->

<!--                                    <tr>-->
<!--                                        <td>7</td>-->
<!--                                        <td>探测成功率-->
<!--                                        </td>-->
<!--                                        <td>≥95%-->
<!--                                        </td>-->
<!--                                    </tr>-->

<!--                                    <tr>-->
<!--                                        <td>8</td>-->
<!--                                        <td>测向精度-->
<!--                                        </td>-->
<!--                                        <td>≤3°-->
<!--                                        </td>-->
<!--                                    </tr>-->

<!--                                    <tr>-->
<!--                                        <td>9</td>-->
<!--                                        <td>定位精度-->
<!--                                        </td>-->
<!--                                        <td>≤30m-->
<!--                                        </td>-->
<!--                                    </tr>-->

<!--                                    <tr>-->
<!--                                        <td>10</td>-->
<!--                                        <td>跟踪性能-->
<!--                                        </td>-->
<!--                                        <td>0m/s~20m/s-->
<!--                                        </td>-->
<!--                                    </tr>-->

<!--                                    <tr>-->
<!--                                        <td>11</td>-->
<!--                                        <td>刷新时间-->
<!--                                        </td>-->
<!--                                        <td>≤2s-->
<!--                                        </td>-->
<!--                                    </tr>-->

<!--                                    <tr>-->
<!--                                        <td>12</td>-->
<!--                                        <td>多目标轨迹跟踪数量-->
<!--                                        </td>-->
<!--                                        <td>≥3-->
<!--                                        </td>-->
<!--                                    </tr>-->
<!--                                    </tbody>-->
<!--                                </table>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                </div>

            </div>
            <div class="compose">
                <div class="text" ref="text">
                    <h3 class="title"><span>产品形态</span></h3>
                    <div>
                        <h4>多模态无人机</h4>
                        <p>综合利用多种传感器技术的无人机，具备多方面的监测和应对能力。</p>
                    </div>
                    <div class="img">
                        <img src="../../../assets/solution/fanwu/FG20M.png" alt="" style="width: 70%">
                        <p>多模态无人机</p>
                    </div>
                    <div>
                        <h4>固定台站式无人机侦测反制</h4>
                        <p> 在固定位置设置专门设备，用于监测和应对周围无人机的行为。</p>
                    </div>
                    <div class="img">
                        <img src="../../../assets/solution/fanwu/drone_model2.png" style="width: 60%">
                        <p>固定台站式无人机侦测反制</p>
                    </div>
                    <div>
                        <h4>无人机防控指挥车</h4>
                        <p> 一种移动式指挥车辆，集成了无人机侦测与反制设备，用于灵活应对不同场景下的无人机威胁。</p>
                    </div>
                    <div class="img">
                        <img src="../../../assets/solution/fanwu/drone_model1.png" alt="">
                        <p>无人机防控指挥车</p>
                    </div>
                    <h3 class="title"><span>应用场景</span></h3>
                    <div>
                        <h4>重大活动保障</h4>
                        <p>在重大活动空域实时掌控监测区无人机态势情况，快速定位非法无人机，防范其对活动造成安全隐患。</p>
                        <img src="@/assets/solution/fanwu/anli1.png" alt="">
                    </div>
                    <div>
                        <h4>低空要地防护</h4>
                        <p>监测铁路、机场、化工厂、边境等重要场所低空空域，及时定位威胁安全的无人机，保障低空安全。</p>
                        <img src="@/assets/solution/fanwu/anli2.png" alt="">
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
export default {
    data() {
        return {
            pageWidth: window.innerWidth
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.$nextTick(() => {
            const text = this.$refs.text;
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        text.classList.add('animate__animated', 'animate__fadeInLeft');
                        observer.disconnect(); // 停止观察
                    }
                });
            });
            observer.observe(text);
        })
        this.$nextTick(() => {
            const img = this.$refs.img;
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        img.classList.add('animate__animated', 'animate__fadeInRight');
                        observer.disconnect(); // 停止观察
                    }
                });
            });
            observer.observe(img);
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.pageWidth = window.innerWidth;
        }
    }
}
</script>

<style scoped lang="less">
@import "../../../styles/spectrum/droneDetection";
@import "../../../styles/spectrum/radioMonitoring";

</style>
